angular.module('natgeo').controller('LoadingScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'SoundEngine',
function LoadingScreen($scope, element, ScreenFactory, manager, container, SoundEngine)
{

  var screen = ScreenFactory( element.attr('id'), element );
  
  screen.once('introBefore', function()
  {
    anim8.save('loadingSprocketIntro', {
      keyframe: {
        from: {
          opacity: 0,
          scale: 0.9,
          translateX: -10
        },
        to: {
          opacity: 1,
          scale: 1,
          translateX: 0
        }
      },
      initial: {
        origin: 'left bottom'
      },
      units: {
        translateX: '%'
      }
    });

    anim8.save('loadingMessageBotIntro', {
      keyframe: {
        from: {
          opacity: 0,
          scale: 0.9,
          translateX: 10
        },
        to: {
          opacity: 1,
          scale: 1,
          translateX: 0
        }
      },
      initial: {
        origin: 'right bottom'
      },
      units: {
        translateX: '%'
      }
    });

    anim8.save('loadingRunnerBotIntro', {
      keyframe: {
        from: {
          opacity: 0,
          scale: 0.9,
          translateX: -50
        },
        to: {
          opacity: 1,
          scale: 1,
          translateX: 0
        }
      },
      initial: {
        origin: 'left bottom'
      },
      units: {
        translateX: '%'
      }
    });

  });

  screen.facts = [
    'The International Space Station has a robotic arm that\'s used to catch spacecraft carrying supplies for the crew.',
    '"Robot" comes from the Czech word robota, meaning "drudgery."',
    'The smallest humanlike robot is six inches tall and can walk, kick, and do pushups.',
    'A robot lifeguard named EMILY can detect swimmers in distress and swim as fast as 40 miles an hour to reach them.',
    'At Hong Kong\'s Robot Kitchen, robots greet, seat, and serve diners.',
    'A Swiss team of researchers built a robot tiny enough to swim through human arteries.',
    'A robot performed the marriage ceremony for a couple in Japan.',
    'Leonardo da Vinci drew up (the first known?) plans for a humanoid machine in 1495.'
  ];

  screen.waitMaxTime = 8000;
  screen.ended = false;
  screen.stopped = false;
  screen.readyed = false;

  screen.start = function(target, fact, waitTime)
  {
    screen.stopped = false;
    screen.readyed = false;
    screen.ended = false;
    screen.target = target;
    screen.waitTime = anim8.coalesce( waitTime, screen.waitMaxTime );

    if (screen._fact)
    {
      if (fact)
      {
        screen._fact.html( screen.facts[ Math.floor( Math.random() * screen.facts.length ) ] ); 
      }
      else
      {
        screen._fact.html( '' );
      }
    }

    setTimeout( screen.stop, screen.waitTime );

    SoundEngine.play( 'gear-loopit', {loop:-1, delay:1000} );
  };

  screen.ready = function()
  {
    screen.readyed = true;

    if (screen.stopped)
    {
      screen.end();
    }
  };

  screen.stop = function()
  {
    screen.stopped = true;

    // if (screen.readyed)
    // {
      screen.end();
    // }
  };

  screen.end = function()
  {
    if ( !screen.ended )
    {
      screen.ended = true;

      SoundEngine.stopAll();
      
      manager.transition( screen.target );
    }
  };

}]);